var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.keyError || _vm.hasSignedContract
      ? _c("div", [_c("h1", [_vm._v("This Agreement has been signed.")])])
      : _c("div", { staticClass: "w-full md:w-3/4" }, [
          _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
            _vm._v(
              _vm._s(
                _vm.event && _vm.event.festival ? _vm.event.festival.title : ""
              ) + " Collaborator Agreement"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "pb-10 mb-10 border-b border-gray-medium" }, [
            _vm._v(
              "All Reimagine collaborators must sign a collaborator agreement, which includes terms and conditions concerning your rights and responsibilities.  If the collaborator is an organization, you must be authorized to sign on behalf of the organization.  If you are not authorized, you may send an email below to a representative of the organization who is authorized to sign."
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "w-full my-3 overflow-y-scroll mb-12 contract-text",
            domProps: { innerHTML: _vm._s(_vm.contractLegal) },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-12" },
            [
              _c("label", { ref: "signDate", attrs: { for: "signDate" } }, [
                _vm._v("\n                Date "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("datepicker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  id: "signDate",
                  name: "signDate",
                  format: "yyyy-MM-dd",
                },
                model: {
                  value: _vm.form.signDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "signDate", $$v)
                  },
                  expression: "form.signDate",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("signDate"),
                      expression: "errors.has('signDate')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("signDate")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { ref: "name", attrs: { for: "name" } }, [
              _vm._v("\n                Your Name "),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.name,
                  expression: "form.name",
                },
              ],
              attrs: { id: "name", type: "text", name: "name" },
              domProps: { value: _vm.form.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("name"),
                    expression: "errors.has('name')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("name")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c(
              "label",
              { ref: "organizationName", attrs: { for: "organizationName" } },
              [
                _vm._v(
                  "\n                Organization Name (if applicable)\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.organizationName,
                  expression: "form.organizationName",
                },
              ],
              attrs: {
                id: "organizationName",
                type: "text",
                name: "organizationName",
              },
              domProps: { value: _vm.form.organizationName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "organizationName", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("organizationName"),
                    expression: "errors.has('organizationName')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("organizationName")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { ref: "title", attrs: { for: "title" } }, [
              _vm._v(
                "\n                Your Position/Title at Organization (if applicable)\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.title,
                  expression: "form.title",
                },
              ],
              attrs: { id: "title", type: "text", name: "title" },
              domProps: { value: _vm.form.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "title", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("title"),
                    expression: "errors.has('title')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("title")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { ref: "address_1", attrs: { for: "address_1" } }, [
              _vm._v("\n                Address "),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.address_1,
                  expression: "form.address_1",
                },
              ],
              attrs: { id: "address_1", type: "text", name: "address_1" },
              domProps: { value: _vm.form.address_1 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "address_1", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("address_1"),
                    expression: "errors.has('address_1')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("address_1")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12 flex flex-wrap" }, [
            _c(
              "div",
              { staticClass: "w-full md:w-1/3 md:pr-2 mb-12 md:mb-0" },
              [
                _c("label", { ref: "city", attrs: { for: "city" } }, [
                  _vm._v("\n                    City "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.city,
                      expression: "form.city",
                    },
                  ],
                  attrs: { id: "city", type: "text", name: "city" },
                  domProps: { value: _vm.form.city },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "city", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("city"),
                        expression: "errors.has('city')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("city")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full md:w-1/3 md:pr-2 mb-12 md:mb-0" },
              [
                _c("label", { ref: "state", attrs: { for: "state" } }, [
                  _vm._v("\n                    State "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.state,
                      expression: "form.state",
                    },
                  ],
                  attrs: { id: "state", type: "text", name: "state" },
                  domProps: { value: _vm.form.state },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "state", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("state"),
                        expression: "errors.has('state')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("state")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "w-full md:w-1/3" }, [
              _c("label", { ref: "zip", attrs: { for: "zip" } }, [
                _vm._v("\n                    Zip "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.zip,
                    expression: "form.zip",
                  },
                ],
                attrs: { id: "zip", type: "text", name: "zip" },
                domProps: { value: _vm.form.zip },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "zip", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("zip"),
                      expression: "errors.has('zip')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("zip")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { ref: "email", attrs: { for: "email" } }, [
              _vm._v("\n                Email "),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "'required|email'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email",
                },
              ],
              attrs: { id: "email", type: "text", name: "email" },
              domProps: { value: _vm.form.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "email", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("email"),
                    expression: "errors.has('email')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("email")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { ref: "phone", attrs: { for: "phone" } }, [
              _vm._v("\n                Phone "),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.phone,
                  expression: "form.phone",
                },
              ],
              attrs: { id: "phone", type: "text", name: "phone" },
              domProps: { value: _vm.form.phone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "phone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("phone"),
                    expression: "errors.has('phone')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("phone")))]
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button mb-12", on: { click: _vm.agree } },
            [_vm._v("Agree")]
          ),
          _vm._v(" "),
          !_vm.isByEmail
            ? _c("div", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button button__small mb-12",
                    on: { click: _vm.emailForSignature },
                  },
                  [_vm._v("Email for Signature")]
                ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-10" }, [
      _c("p", [
        _vm._v(
          "By completing the information below, I acknowledge and agree: (A) I am electronically signing this Agreement and I have read, understood, and agree to the terms of this Agreement and Reimagine’s website "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.letsreimagine.org/terms-conditions/",
              target: "_blank",
            },
          },
          [_vm._v("Terms & Conditions")]
        ),
        _vm._v(" and "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.letsreimagine.org/privacy-cookies/",
              target: "_blank",
            },
          },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(
          "; and (B) if I am signing on behalf of an organization, I warrant that I am authorized by the organization to sign on its behalf and to bind it to the terms of this Agreement."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-5" }, [
      _c("span", { staticClass: "font-sans-bold" }, [
        _vm._v(
          "Is someone else the appropriate person to complete this agreement?"
        ),
      ]),
      _vm._v(" Email it to them for signature.\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }